import { render, staticRenderFns } from "./usuario_prefeitura.vue?vue&type=template&id=52d4b938"
import script from "./usuario_prefeitura.vue?vue&type=script&lang=js"
export * from "./usuario_prefeitura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports